export const UPLOAD_EVENTS = {
  START_ATTEMPT: 'videos.upload.start.attempt',
  SUCCESS: 'videos.upload.success',
  FAIL: 'videos.upload.fail',
};



// WEBPACK FOOTER //
// ./src/dashboard/redux/server/actions/video/upload-events.js